module.exports = __webpack_public_path__ + "static/barnes&noble-e6ecce171541b7e1efbc75d2418c7ea9.png";